module.exports = __webpack_public_path__ + "img/tklx.9b4ac50b.png";